export const dataFields = {
  Estabelecimento: {
    callback: (item) => {
      let dados = JSON.parse(item.dados)
      if (dados != null) {
        return dados.no_unidade_saude ?? ''
      }
      return ''
    },
  },
  Equipe: {
    callback: (item) => {
      let dados = JSON.parse(item.dados)
      if (dados != null) {
        return dados.no_equipe ?? ''
      }
      return ''
    },
  },
  INE: {
    field: 'ine',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  Idade: 'idade',
  Pessoas: 'pessoas_idade',
}

export const infoHtml = ``
